import {
  HeaderContainer,
  ScrollableContainer,
  Title,
  CloseIcon,
} from './styled';
import loadable from '@loadable/component';
import type { EventCategory } from '@/constants/events';
const CompanyFeed = loadable(() => import('@/components/CompanyFeed'), {
  resolveComponent: (component) => component.CompanyFeed,
});

interface Props {
  title: string;
  filter?: EventCategory;
  lookup: string | null;
  show?: boolean;
  onClose?: () => void;
}

export function RecentUpdatesList(props: Props) {
  return (
    <>
      <HeaderContainer data-cy-id="recent-updates">
        <Title>{props.title}</Title>
        <button data-cy-id="recent-updates-close" onClick={props.onClose}>
          <CloseIcon />
        </button>
      </HeaderContainer>
      <ScrollableContainer>
        <CompanyFeed
          lookup={props.lookup}
          isCompanyReport
          filterByEventCategory={props.filter}
        />
      </ScrollableContainer>
    </>
  );
}
